import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getInventoryMovement, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
import { ReportInventoryMovementCrumb } from 'utils/breadcrumbInfo';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class InventoryMovement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `InventoryMovementBeginDate`);
        this.props.formInput(date, `InventoryMovementEndDate`);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let productId = this.props.selectProductId || 0;

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/inventoryMovement?branchId=${branch}&startDate=${beginDate}&endDate=${endDate}&pageNumber=1&pageSize=9999&productId=${productId}`, "InventoryMovement");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getProductOptions = () => {
        if (this.props.searchMethod == "sku") {
            return (this.props.products || []).map(item => {
                return {
                    text: item.sku,
                    value: item.id,
                    categoryId: item.id
                };
            });
        } else {
            return (this.props.products || []).map(item => {
                return {
                    text: item.name,
                    value: item.id,
                    categoryId: item.id
                };
            });
        }
    }

    getReport = () => {
        let startDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchId = this.props.branch || this.props.loggedBranch;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let productId = this.props.selectProductId || 0;
        this.props.getInventoryMovement({ startDate, endDate, pageNumber, pageSize, branchId, productId });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        const totalRow = this.props.inventoryMovement.length > 0 ? this.props.inventoryMovement[0].totalrow : 0;

        return (
            <Grid headerContent={ReportInventoryMovementCrumb}>
                <PageHeader title={LOOKUP.report.InventoryMovement.text}
                    description={LOOKUP.report.InventoryMovement.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                    products={this.getProductOptions()}
                    searchMethod={this.props.searchMethod}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody && this.props.inventoryMovement &&
                    <CardSimple>
                        <Body
                            inventoryMovement={this.props.inventoryMovement}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branch}
                            inventoryMovementProductInfo={this.props.inventoryMovementProductInfo}
                        />
                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    return {
        brachOptions: brachOptions,
        inventoryMovement: state.reports.inventoryMovement,
        loggedBranch: state.common.branchId,
        beginDate: state.form.InventoryMovementBeginDate,
        endDate: state.form.InventoryMovementEndDate,
        branch: state.form.InventoryMovementBranchOption,
        selectProductId: state.form.InventoryMovementProductId,
        products: state.entity.productList,
        inventoryMovementProductInfo: state.reports.inventoryMovementProductInfo,
        searchMethod: state.form["productPOSearchMethod"]
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getInventoryMovement: model => dispatch(getInventoryMovement(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(InventoryMovement));